/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AutoBursh.vue?vue&type=template&id=4fe966a8&scoped=true"
import script from "./AutoBursh.vue?vue&type=script&lang=js"
export * from "./AutoBursh.vue?vue&type=script&lang=js"
import style0 from "./AutoBursh.vue?vue&type=style&index=0&id=4fe966a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe966a8",
  null
  
)

export default component.exports